import { render } from "./list.actopntempl.vue?vue&type=template&id=42a298a4&lang=html"
import script from "./list.actopntempl.vue?vue&type=script&lang=js"
export * from "./list.actopntempl.vue?vue&type=script&lang=js"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__